import {React, _, computed, useContext, useMemo} from '@api'
import {AssortmentCardStore, VipLocalStore} from '@modules'
import { GroupByGroupsQueryManager } from '@modules'
import {StoresInstance} from '@stores/StoresInstance'

export const GroupByViewRootStoreContext = React.createContext<RootGroupsStore>(undefined)
export const useGroupByRootStore = () => useContext(GroupByViewRootStoreContext)

export class RootGroupsStore extends VipLocalStore {
  sentry = {markedInitialLoad: false}

  constructor(stores: StoresInstance, public props: { assortmentCard?: AssortmentCardStore}) {
    super(stores)
    this.mgr = new GroupByGroupsQueryManager(stores, null, {assortmentCard: props.assortmentCard})
    this.catalog.groupBy.viewStore = this
  }

  mgr : GroupByGroupsQueryManager

  // region Properties

  @computed get customAttribute() {
    const {grouping} = this
    return grouping.def
  }

  @computed get groupTitle() {
    return this.grouping.labelFor()
  }

  @computed get grouping() {
    const {groupName, catalog: {groupBy: {groupingByName}}} = this
    return groupingByName.get(groupName)
  }

  @computed get childGroup() {
    const {level, catalog: {groupBy: {hierarchy}}} = this
    return hierarchy[level + 1]
  }

  @computed get columns() {
      const {groupBy: {hierarchyGroups}} = this

      return hierarchyGroups.length === 3 ? 2 : 3
  }


  @computed get childGrouping() {
    const {level, catalog: {groupBy: {hierarchy, groupingByName}}} = this
    if (level + 1 >= hierarchy.length) { return null }
    return groupingByName.get(hierarchy[level + 1])
  }

  @computed get groupName(): string {
    const {catalog: {groupBy: {hierarchy}}} = this

    return _.first(hierarchy.slice()) || ''
  }

  // endregion

  get data() { return this.mgr.data }

  // region Virtualization

  @computed get expandedGroups() {
    if (!this.grouping) return []
    const {data, grouping: {isExpanded}} = this

    return data.filter(({id}) => isExpanded(id))
  }

  get level() { return 0 }

  @computed get childGroupId() {
    const {catalog: {groupBy: {hierarchy}}, level} = this
    return hierarchy.length <= 1 ? null : hierarchy[level + 1]
  }

  @computed get inlineStyles() {
    const {groupBy: {hierarchy, settings: {settingsForLevel: {0: {swatchSize}}}}} = this
    return {
      //'--group-zoom': 1,
      '--group-depth': hierarchy.length,
      '--group-swatch-size': `${swatchSize}px`
    }
  }
}




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/RootGroupsStore.tsx